import { useMutation, useQueryClient } from "@tanstack/react-query";

import { API_URL } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

export const useUploadFileToGoogleStore = (provider = "google") => {
  const auth = useAuth();
  const userContext = useUser();
  const workspaceId = userContext?.activeWorkspaceId;
  const qc = useQueryClient();

  return useMutation(
    async (params: { file: File; storeName: string }) => {
      const formData = new FormData();
      formData.append("file", params.file);
      formData.append("workspace_id", String(workspaceId));
      formData.append("store_name", params.storeName);
      formData.append("provider", provider);

      const response = await fetch(
        `${API_URL}/api/dashboard/v2/google-file-search-store/file/upload`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${auth?.userToken ?? ""}`,
          },
          body: formData,
        },
      ).then(handleResponse);

      if (response && typeof response === "object" && "success" in response) {
        if (response.success === false) {
          const errorMessage =
            (response as { message?: string }).message || "Failed to upload file";
          throw new Error(errorMessage);
        }
      }

      return response;
    },
    {
      onSuccess: (_data, variables) => {
        qc.invalidateQueries({
          queryKey: [
            "google-file-search-store-documents",
            variables.storeName,
            workspaceId,
            provider,
          ],
        });
      },
    },
  );
};
